import { FormControlLabel, Switch } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { toggleRemoteControl } from 'redux/slices';

export function RemoteControlToggle() {
  const dispatch = useDispatch();
  const { remoteControlEnabled } = useSelector((state) => state.game);

  return (
    <FormControlLabel
      control={(
        <Switch
          checked={remoteControlEnabled}
          onChange={() => dispatch(toggleRemoteControl())}
        />
      )}
      label="Controle Remoto"
    />
  );
}
